// @ts-nocheck
import { useState, useEffect, useCallback } from "react";

import CancelIcon from "@material-ui/icons/Cancel";
import WarningIcon from "@material-ui/icons/Warning";

import {
  PageContainer,
  WhiteBox,
  CloseButton,
  Button,
} from "../ModalWelcome/styles";

import { BoxContent, CautionBox, CardButtons } from "./styles";

// Marca que este cliente já viu o aviso (por navegador).
const STORAGE_KEY = "@Central:avisoMudancaEndereco";

// O aviso some sozinho depois desta data, para não perseguir quem
// entrar na Central meses depois da mudança.
const EXIBIR_ATE = new Date(2026, 10, 20, 23, 59, 59); // 20/11/2026

// `ocultar`: cliente só com pedidos do plano Análise não envia nada pelos
// Correios — o aviso de endereço não faz sentido para ele.
export function ModalMudancaEndereco({ ocultar = false }) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (ocultar) {
      setOpen(false);
      setVisible(false);
      return;
    }
    if (new Date() > EXIBIR_ATE) return;

    let jaViu = null;
    try {
      jaViu = localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      // navegador sem acesso a storage (aba anônima, cookies bloqueados):
      // melhor mostrar o aviso de novo do que esconder por engano.
      jaViu = null;
    }
    if (jaViu) return;

    setOpen(true);
    setTimeout(() => {
      setVisible(true);
    }, 400);
  }, [ocultar]);

  const handleCloseModal = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (err) {
      // sem storage o aviso reaparece no próximo acesso; não quebra nada.
    }
    setOpen(false);
    setTimeout(() => {
      setVisible(false);
    }, 600);
  }, []);

  return (
    <PageContainer open={open} visible={visible}>
      <WhiteBox>
        <CloseButton onClick={handleCloseModal}>
          Fechar
          <CancelIcon />
        </CloseButton>
        <BoxContent active>
          <h4>Nosso escritório mudou de endereço</h4>
          <p className="body">A partir de 21/09, passamos a funcionar em:</p>
          <p className="body">
            <strong>Rua Rodrigo Silva, 30 – sala Cidadania Já – Centro</strong>
            <br />
            <strong>Rio de Janeiro – RJ – CEP 20011-040</strong>
          </p>
          <CautionBox>
            <span>
              <WarningIcon />
              <p className="caution">
                Já enviou seus documentos para o endereço antigo?
              </p>
            </span>
            <p className="caution-body">
              Pode ficar tranquilo: continuamos recebendo normalmente o que foi
              enviado para a Praia de Botafogo, 518. Nada se perde. Para novos
              envios, favor usar o novo endereço.
            </p>
          </CautionBox>
          <CardButtons>
            <Button bgColor="var(--principal-40)" onClick={handleCloseModal}>
              Entendi
            </Button>
          </CardButtons>
        </BoxContent>
      </WhiteBox>
    </PageContainer>
  );
}
